import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { HeaderCopy } from '@models/cms/header.model';
import { AccordionModule } from 'ngx-bootstrap/accordion';

@Component({
  selector: 'app-top-menu-mobile',
  standalone: true,
  imports: [CommonModule, RouterModule, AccordionModule],
  templateUrl: './top-menu-mobile.component.html',
  styleUrl: './top-menu-mobile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopMenuMobileComponent {
  @Input() headerCopy: HeaderCopy;
  @Output() bookNowClick = new EventEmitter<void>();

  openedTravelInfoGroup = false;

  private router = inject(Router);

  onBookNowClick(): void {
    this.bookNowClick.emit();
  }

  goTo(url?: string): void {
    if (url) {
      this.setOpenedTravelInfoGroup(false);
      this.router.navigate([url]);
    }
  }

  setOpenedTravelInfoGroup(opened: boolean): void {
    this.openedTravelInfoGroup = opened;
  }
}
